export type LogEntry = {
    date: string;
    hours: number;
    note: string | null;
};

export type StoreLogEntriesResponse = {
    workItemId: number;
    newCompletedWork: number;
    writtenEntries: LogEntry[];
};

export type ApplyWorkLogsAction = 'add' | 'remove';

export type ApplyWorkLogsEntry = {
    workItemId: number;
    action: ApplyWorkLogsAction;
    date: string;
    hours: number;
    note: string | null;
};

export type ApplyWorkLogsCommand = {
    entries: ApplyWorkLogsEntry[];
};

export type ApplyWorkLogsResponse = {
    results: StoreLogEntriesResponse[];
};

export type PendingAction = 'add' | 'update' | 'remove';

export type PendingEntry = {
    id: string;
    workItemId: number;
    workItemTitle: string;
    workItemType: string;
    date: string;
    hours: number;
    action: PendingAction;
};

export type PendingGroup = readonly [date: string, entries: PendingEntry[]];

const sortByDateThenItem = (a: PendingEntry, b: PendingEntry): number => {
    if (a.date !== b.date) {
        return a.date.localeCompare(b.date);
    }
    return a.workItemId - b.workItemId;
};

export const groupPendingByDate = (pending: readonly PendingEntry[]): PendingGroup[] => {
    const sorted = pending.toSorted(sortByDateThenItem);
    const map = new Map<string, PendingEntry[]>();
    for (const entry of sorted) {
        const list = map.get(entry.date) ?? [];
        list.push(entry);
        map.set(entry.date, list);
    }
    return [...map.entries()];
};
